import React from 'react';

import { IconCircleArrowLeft, IconDownload } from '@tabler/icons-react';

import { ButtonWithIcon } from '../../../../../ui-kit';

interface Props {}

const detailsCfg = [
  { label: 'Adress', key: '' },
  { label: 'Property Type', key: '' },
  { label: 'Subtype', key: '' },
  { label: 'Key Tenants', key: '' },
  { label: 'Investment Type', key: '' },
  { label: 'Square Footage', key: '' },
  { label: 'Year Built', key: '' },
  { label: 'Stories', key: '' },
  { label: 'Lot Size (acres)', key: '' },
  { label: 'Class', key: '' },
  { label: 'Sale Condition', key: '' },
  { label: 'Repayment Source', key: '' },
  { label: 'Secondary Payment Source', key: '' },
  { label: 'Units', key: '' },
  { label: 'Buildings', key: '' },
  { label: 'Zoning', key: '' },
  { label: 'LTV', key: '' },
  { label: 'Rent/Sq Ft', key: '' },
  { label: 'Price/Unit', key: '' },
  { label: 'Occupancy Rate', key: '' },
  { label: 'Interest Rate', key: '' },
  { label: 'Index Name', key: '' },
  { label: 'Margin', key: '' },
  { label: 'Rate Adjustment', key: '' },
  { label: 'Primary Risk Factor', key: '' },
];

export const CREDetails = ({}: Props) => {
  const labelClasses = 'text-[10px] not-italic font-medium leading-[12px] text-slate-400 mb-2';
  const valuesClasses = 'text-[12px] not-italic font-medium leading-[20px] text-white';
  return (
    <div className="mb- w-full px-[16px]">
      <div className="mb-4  pt-2">
        <p className={labelClasses}>Property Name</p>
        <p className={valuesClasses}>Property Name</p>
      </div>
      <div className="mb-4  pt-2">
        <p className={labelClasses}>Property Description & Investment Highlights</p>
        <p className={valuesClasses}>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur corporis delectus
          distinctio dolore dolores error est et, incidunt inventore libero neque, nesciunt nobis
          omnis quasi quis quod reiciendis rem, repellat rerum similique unde velit voluptas.
          Dignissimos fugiat ipsum laboriosam modi, mollitia nesciunt nihil perspiciatis quam quia
          quisquam ratione, suscipit unde!
        </p>
        <div className="mt-2">
          <ul className={`list-disc columns-2 gap-x-8 pl-5 ${valuesClasses}`}>
            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, eveniet.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, eveniet.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, eveniet.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, eveniet.</li>
          </ul>
        </div>
      </div>
      <div className="mb-4  pt-2">
        <p className={labelClasses}>Download</p>
        <ButtonWithIcon
          size="small"
          label={'Property & Loan Summary'}
          icon={<IconDownload size={16} />}
          iconPosition="right"
          type="link"
          className="items-center border-none !p-0"
          // onClick={handleRequestClose}
          iconClass="w-5 h-5"
        />
      </div>
      <div className="mt-2">
        <ul className={`list-disc columns-2 gap-x-8 ${valuesClasses}`}>
          {detailsCfg.map((cfg) => (
            <li className="flex w-full items-center justify-between">
              <p className={`${labelClasses}`}>{cfg.label}</p>
              <p className={`${valuesClasses} w-[30%] text-right`}>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque delectus ducimus
                eveniet ipsum quod recusandae!
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div className="mb-4  pt-2">
        <p className={labelClasses}>Amenities</p>
        <ul
          className={`list-disc columns-1 gap-x-8 pl-5 sm:columns-2 md:columns-3 lg:columns-4 ${valuesClasses}`}
        >
          {['Fenced Lot'].map((item) => (
            <li>{item}</li>
          ))}
        </ul>
      </div>
      <div className="mb-4  pt-2">
        <p className={labelClasses}>Utilities</p>
        <ul className={`column-2 list-disc gap-x-8 pl-5 [column-width:8rem] ${valuesClasses}`}>
          {['Lighting', 'Gas', 'Water', 'Sewer'].map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="mb-4  pt-2">
        <p className={labelClasses}>Space Availability</p>
        <ul className={`column-2  gap-x-8  [column-width:4rem] ${valuesClasses}`}>
          {['Lighting', 'Gas', 'Water', 'Sewer'].map((item) => (
            <li key={item} className="mb-2 break-inside-avoid">
              <p className={`${valuesClasses} !text-[10px]`}>Space</p>
              <p className={valuesClasses}>1st Floor</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
